import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { TranslateModule } from '@ngx-translate/core';

import { FullCapture } from './full-capture';
import { DocIllustration } from './doc-illustration/doc-illustration';
import { Docpic } from '../docpic/docpic';
import { QrCapture } from '../qr-capture/qr-capture';
import { FocusRingComponent } from '../docpic/focus-ring/focus-ring.component';

/**
 * Houses the vendored brdocs guided-capture UI (ported from the Angular-20
 * `brdocs` reference to Angular-15 NgModule). Exports {@link FullCapture}
 * (`<brdocs-capture-flow>` / `<app-full-capture>`) — the whole guided flow
 * (welcome → camera/upload → front/back → QR/MRZ → compiled result) — for the
 * KYC modal and the dev testbench.
 */
@NgModule({
  declarations: [FullCapture, DocIllustration, Docpic, QrCapture, FocusRingComponent],
  imports: [
    CommonModule,
    MatButtonModule,
    MatFormFieldModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatSelectModule,
    MatSnackBarModule,
    TranslateModule,
  ],
  exports: [FullCapture],
})
export class BrdocsCaptureModule {}
